function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.25781 2.48586V29.4859H16.1053L24.7653 14.4859H46.7653V2.48586H6.25781Z",
  fill: "#DB4437"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.25781 2.48586V29.4859H16.1053L24.7653 14.4859H46.7653V2.48586H6.25781Z",
  fill: "url(#paint0_linear_28189_31589)"
}));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.3427 29.3984L6.38523 12.3209L6.24023 12.5709L16.1252 29.5209L16.3427 29.3984Z",
  fill: "#3E2723",
  fillOpacity: 0.15
}));
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.76526 46.4859H23.7078L33.4278 36.7659V29.4859H16.1053L2.76526 6.60586V46.4859Z",
  fill: "#0F9D58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.76526 46.4859H23.7078L33.4278 36.7659V29.4859H16.1053L2.76526 6.60586V46.4859Z",
  fill: "url(#paint1_linear_28189_31589)"
}));
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.2253 29.8184L33.0178 29.6984L23.4203 46.4859H23.7078L33.2328 29.8259L33.2253 29.8184Z",
  fill: "#263238",
  fillOpacity: 0.15
}));
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M2.76526 46.4859H23.7078L33.4278 36.7659V29.4859H16.1053L2.76526 6.60586V46.4859Z",
  fill: "white"
});
var _ref12 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask5_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 14.4859L33.4278 29.4859L23.7078 46.4859H46.7653V14.4859H24.7653Z",
  fill: "#FFCD40"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 14.4859L33.4278 29.4859L23.7078 46.4859H46.7653V14.4859H24.7653Z",
  fill: "url(#paint2_linear_28189_31589)"
}));
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref14 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask6_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 14.4859L33.4278 29.4859L23.7078 46.4859H46.7653V14.4859H24.7653Z",
  fill: "#FFCD40"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 14.4859L33.4278 29.4859L23.7078 46.4859H46.7653V14.4859H24.7653Z",
  fill: "url(#paint3_linear_28189_31589)"
}));
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 14.4859L33.4278 29.4859L23.7078 46.4859H46.7653V14.4859H24.7653Z",
  fill: "white"
});
var _ref17 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask8_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.25781 2.48586V29.4859H16.1053L24.7653 14.4859H46.7653V2.48586H6.25781Z",
  fill: "#DB4437"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.25781 2.48586V29.4859H16.1053L24.7653 14.4859H46.7653V2.48586H6.25781Z",
  fill: "url(#paint4_linear_28189_31589)"
}));
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref19 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask9_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 14.4859V19.7234L44.3653 14.4859H24.7653Z",
  fill: "url(#paint5_radial_28189_31589)"
}));
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M6.25781 2.48586V12.5709L16.1053 29.4859L24.7653 14.4859H46.7653V2.48586H6.25781Z",
  fill: "white"
});
var _ref22 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask11_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.76526 46.4859H23.7078L33.4278 36.7659V29.4859H16.1053L2.76526 6.60586V46.4859Z",
  fill: "#0F9D58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.76526 46.4859H23.7078L33.4278 36.7659V29.4859H16.1053L2.76526 6.60586V46.4859Z",
  fill: "url(#paint6_linear_28189_31589)"
}));
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref24 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask12_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.25781 12.5984L20.5703 26.9084L16.1053 29.4859L6.25781 12.5984Z",
  fill: "url(#paint7_radial_28189_31589)"
}));
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref26 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask13_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.7228 46.4584L28.9628 26.9084L33.4278 29.4859L23.7228 46.4584Z",
  fill: "url(#paint8_radial_28189_31589)"
}));
var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref28 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask14_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 34.4859C30.2881 34.4859 34.7653 30.0087 34.7653 24.4859C34.7653 18.963 30.2881 14.4859 24.7653 14.4859C19.2424 14.4859 14.7653 18.963 14.7653 24.4859C14.7653 30.0087 19.2424 34.4859 24.7653 34.4859Z",
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 32.4859C29.1835 32.4859 32.7653 28.9041 32.7653 24.4859C32.7653 20.0676 29.1835 16.4859 24.7653 16.4859C20.347 16.4859 16.7653 20.0676 16.7653 24.4859C16.7653 28.9041 20.347 32.4859 24.7653 32.4859Z",
  fill: "#4285F4"
}));
var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref30 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask15_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 14.2359C19.2428 14.2359 14.7653 18.7134 14.7653 24.2359V24.4859C14.7653 18.9634 19.2428 14.4859 24.7653 14.4859H46.7653V14.2359H24.7653Z",
  fill: "#3E2723",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.4153 29.4859C31.6853 32.4709 28.4628 34.4859 24.7653 34.4859C21.0653 34.4859 17.8428 32.4709 16.1128 29.4859H16.1028L2.76526 6.60586V6.85586L16.1053 29.7359H16.1153C17.8453 32.7209 21.0678 34.7359 24.7678 34.7359C28.4653 34.7359 31.6878 32.7234 33.4178 29.7359H33.4303V29.4859H33.4153Z",
  fill: "white",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M25.0153 14.4859C24.9728 14.4859 24.9328 14.4909 24.8903 14.4934C30.3553 14.5609 34.7653 19.0059 34.7653 24.4859C34.7653 29.9659 30.3553 34.4109 24.8903 34.4784C24.9328 34.4784 24.9728 34.4859 25.0153 34.4859C30.5378 34.4859 35.0153 30.0084 35.0153 24.4859C35.0153 18.9634 30.5378 14.4859 25.0153 14.4859Z",
  fill: "#3E2723"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.5153 29.8184C34.3653 28.3484 34.8578 26.6484 34.8578 24.8284C34.8578 23.7734 34.6928 22.7584 34.3903 21.8059C34.6278 22.6609 34.7653 23.5584 34.7653 24.4884C34.7653 26.3084 34.2728 28.0084 33.4228 29.4784L33.4278 29.4884L23.7078 46.4884H23.9978L33.5203 29.8284L33.5153 29.8184Z",
  fill: "white",
  fillOpacity: 0.2
}));
var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.4859C36.9155 46.4859 46.7653 36.6361 46.7653 24.4859C46.7653 12.3356 36.9155 2.48586 24.7653 2.48586C12.615 2.48586 2.76526 12.3356 2.76526 24.4859C2.76526 36.6361 12.615 46.4859 24.7653 46.4859Z",
  fill: "white"
});
var _ref32 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask16_28189_31589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 2.73586C36.8728 2.73586 46.6953 12.5184 46.7628 24.6109C46.7628 24.5684 46.7653 24.5284 46.7653 24.4859C46.7653 12.3359 36.9153 2.48586 24.7653 2.48586C12.6153 2.48586 2.76526 12.3359 2.76526 24.4859C2.76526 24.5284 2.76776 24.5684 2.76776 24.6109C2.83526 12.5184 12.6578 2.73586 24.7653 2.73586Z",
  fill: "white",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.7653 46.2359C36.8728 46.2359 46.6953 36.4534 46.7628 24.3609C46.7628 24.4034 46.7653 24.4434 46.7653 24.4859C46.7653 36.6359 36.9153 46.4859 24.7653 46.4859C12.6153 46.4859 2.76526 36.6359 2.76526 24.4859C2.76526 24.4434 2.76776 24.4034 2.76776 24.3609C2.83526 36.4534 12.6578 46.2359 24.7653 46.2359Z",
  fill: "#3E2723",
  fillOpacity: 0.15
}));
var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M26.7653 46.4859C38.9155 46.4859 48.7653 36.6361 48.7653 24.4859C48.7653 12.3356 38.9155 2.48586 26.7653 2.48586C14.615 2.48586 4.76526 12.3356 4.76526 24.4859C4.76526 36.6361 14.615 46.4859 26.7653 46.4859Z",
  fill: "url(#paint9_radial_28189_31589)"
});
var _ref34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_28189_31589",
  x1: 8.09956,
  y1: 19.2411,
  x2: 21.2246,
  y2: 11.5744,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A52714",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#A52714",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_28189_31589",
  x1: 28.4833,
  y1: 41.6096,
  x2: 13.8998,
  y2: 33.0681,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#055524",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#055524",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_28189_31589",
  x1: 31.2298,
  y1: 12.9369,
  x2: 34.902,
  y2: 29.0184,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EA6100",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#EA6100",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_28189_31589",
  x1: 31.2298,
  y1: 12.9369,
  x2: 34.902,
  y2: 29.0184,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EA6100",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#EA6100",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_28189_31589",
  x1: 8.09956,
  y1: 19.2411,
  x2: 21.2246,
  y2: 11.5744,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A52714",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#A52714",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_28189_31589",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.8093 14.4729) scale(21.0195 21.0195)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E2723",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E2723",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_28189_31589",
  x1: 28.4833,
  y1: 41.6096,
  x2: 13.8998,
  y2: 33.0681,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#055524",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#055524",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_28189_31589",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.23406 12.6159) scale(19.511)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E2723",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E2723",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_28189_31589",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.7263 24.5204) scale(21.9675 21.9675)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#263238",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#263238",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_28189_31589",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.3368 8.48936) scale(44.1865)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_28189_31589"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white",
  transform: "translate(0.765259 0.485855)"
})));
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28189_31589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref2), _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref4), _ref5, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref6), _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref8), _ref9, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref10), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_28189_31589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 32,
    height: 41
  }, _ref11), _ref12), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref13), _ref14, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref15), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_28189_31589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 14,
    width: 24,
    height: 33
  }, _ref16), _ref17), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref18), _ref19, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref20), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_28189_31589)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 41,
    height: 28
  }, _ref21), _ref22), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref23), _ref24, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref25), _ref26, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref27), _ref28, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref29), _ref30, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_28189_31589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 45,
    height: 45
  }, _ref31), _ref32, _ref33), _ref34);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.3293d439971944672e229f2b37567473.svg";
export { ForwardRef as ReactComponent };